<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" title="修改" fontSize="14px" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')" :optional="sbmidarr.length !== 1">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="复制" fontSize="14px" @btnclick="copy"
				:src="require('@/assets/icon/icon-fpcpx.png')" :optional="sbmidarr.length !== 1">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.browse" title="查看" fontSize="14px" @btnclick="Look"
				:src="require('@/assets/icon/look.png')" :optional="sbmidarr.length !== 1">
			</Commonbtn>
			<CommonbtnUpLoad v-if="qx.add" style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF"
				title="导入" fontSize="14px" @getFile="customerImport" types="file"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<a class="Dowload" v-if="qx.add" @click="SeconDowload">导入模版下载</a>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable ref="comtable" @handleSelectionChange="(e)=>sbmidarr = e.map(it => it.INMID)"
				@onRowClick="(e)=>cusId = e.INMID" colnum="7" :tableData="tableData" :headerData="headerData"
				height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>

		<DialogFrom width="1100px" :title="EidtTitle" :dialogVisible="dialogVisibles" @cancel="dialogVisibles = false"
			@dialogOK="dialogOK">
			<div class="from">
				<div v-for="(item, index) of fromdataadd" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="addjxa" :btx="item.btx" :radio="item.radio" :widths="item.widths"
						:pt="item.pt" :options="item.options" @remoteMethod="remoteMethodtows"
						@remoteMethodtowHP="remoteMethodtowHP" @invClass="handInvClass" :inputdata="item.inputdata"
						:title="item.title" :fontSize="item.fontSize" :color="item.color" :event="item.event"
						:lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types"
						:inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max"
						:checkboxdata="item.checkboxdata" :multiple="item.multiple" :disabled="item.disabled"
						:disabledHB="item.disabledHB">
					</Commondropdownlist>
				</div>
			</div>
		</DialogFrom>

		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg"
			@cancel="dialogVisiblesdrjg = false" @dialogOK="dialogVisiblesdrjg = false">
			<div class="from">
				<Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%" />
			</div>
		</DialogFrom>

		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除吗？</span>
		</Dialog>
	</div>
</template>
<script>
	import Commondropdownlist from "../../../../components/common-dropdownlist.vue";
	import Commontable from "../../../../components/common-table.vue";
	import Commonbtn from "../../../../components/common-btn.vue";
	import Pagination from "../../../../components/pagination.vue";
	import DialogFrom from "../../../../components/dialog-from.vue";
	import fromdata from "../fromData/add";
	import Dialog from "../../../../components/dialog.vue";
	import CommonbtnUpLoad from "../../../../components/common-upload.vue";
	import headerData from "../tableData/headerData";

	import {
		CustomerList,
		InventoryClassList
	} from "@/api/home";
	import {
		GetHelperVBP,
		GetProvinceCityTree,
		GetHelperLevel3,
		GetHelperInvName,
		InfoIMSNTSData,
		AddIMSNTSData,
		EditIMSNTSData,
		DeleteIMSNTSData,
		ImportIMSNTSData,
		DownloadIMSNTS,
		GetHospitalList
	} from "@/api/newsapi";
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			CommonbtnUpLoad,
		},
		props: {
			tableData: {
				type: Array,
				default: [],
			},
			total: {
				type: Number,
				default: 0,
			}
		},
		data: function() {
			return {
				sbmidarr: [],
				dialogVisibles: false,
				dialogVisibledel: false,
				fromdataadd: [],
				cusinfo: null,
				cusId: "",
				title: "",
				EidtTitle: "",
				from: {
					orgCusCode: "",
					newCusCode: "",
					attachmentNames: [],
				},
				headerData: [],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					browse: false
				},
				dialogVisiblesdrjg: false,
				tableDatadrjg: [],
			};
		},
		mounted() {
			this.headerData = JSON.parse(JSON.stringify(headerData));
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata));
			this.QX();
		},
		methods: {
			// 下载导入模板
			async SeconDowload() {
				let {
					data,
					code,
					message
				} = await DownloadIMSNTS({});
				if (code == 0) {
					window.location.href = data;
				} else if (code == 101) {
					this.$message({
						type: "warning",
						message: message,
					});
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
			},
			// 导入
			async customerImport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: "上传中...",
						spinner: "el-icon-loading",
						background: "rgba(255,255,255,0.3)",
					});
					let formData = new FormData();
					formData.append("file", file);
					let res = await ImportIMSNTSData(formData);
					if (res.code == 0) {
						this.$message({
							type: "success",
							message: res.message,
						});
						this.$parent.customerList();
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: "warning",
							message: res.message,
						});
						loading.close();
					} else {
						this.dialogVisiblesdrjg = true;
						this.tableDatadrjg = res.data;
						this.title = "导入结果";
						loading.close();
					}
					loading.close();
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.fromdataadd[0].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName,
						};
						this.fromdataadd[0].options.push(obj);
					});
					this.$forceUpdate();
				}
			},
			//类型
			async getHelperVBP() {
				let {
					code,
					data
				} = await GetHelperVBP({});
				if (code == 0) {
					this.fromdataadd[1].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text,
						};
						this.fromdataadd[1].options.push(obj);
					});
					this.$forceUpdate();
				}
			},
			//省市
			async getProvinceCityTree() {
				let {
					code,
					data
				} = await GetProvinceCityTree({});
				if (code == 0) {
					this.fromdataadd[4].options = data;
				}
			},
			//经销商下拉
			async remoteMethodtows(query) {
				let {
					code,
					data
				} = await CustomerList({
					cusName: query.qurey || query,
				});
				if (code == 0) {
					this.fromdataadd[11].options = [];
					data.data.map((item, index) => {
						let obj = {
							key: item.CusCode,
							value: item.CusName,
						};
						this.fromdataadd[11].options.push(obj);
					});
				}
			}, //医院下拉
			async remoteMethodtowHP(query) {
				let {
					code,
					data
				} = await GetHospitalList({
					HPName: query,
					pageIndex: 1,
					pageSize: 9999,
					HosType: '医院'
				})
				if (code == 0) {
					this.fromdataadd[12].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName,
						}
						this.fromdataadd[12].options.push(obj)
					})
					this.$forceUpdate();
				}
			},
			// 产品名称
			async getHelperLevel3() {
				let {
					code,
					data
				} = await GetHelperLevel3({
					InvClass: this.$refs.addjxa[0].modelvalue
				})
				if (code == 0) {
					if (!this.cusId) {
						this.$refs.addjxa[5].modelvalue = '';
					}
					this.fromdataadd[5].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.key,
							value: item.value,
						};
						this.fromdataadd[5].options.push(obj);
					});
					this.$forceUpdate();
				}
			},
			// 产品名称
			async getHelperInvName() {
				let {
					code,
					data
				} = await GetHelperInvName({
					InvClass: this.$refs.addjxa[0].modelvalue
				})
				if (code == 0) {
					if (!this.cusId) {
						this.$refs.addjxa[6].modelvalue = '';
					}
					this.fromdataadd[6].options = [];
					data.map((item, index) => {
						let obj = {
							key: item.InvName,
							value: item.InvName,
						};
						this.fromdataadd[6].options.push(obj);
					});
					this.$forceUpdate();
				}
			},
			//产线切换
			handInvClass() {
				this.getHelperLevel3();
				this.getHelperInvName();
			},
			// 查看
			Look() {
				if (this.sbmidarr.length === 1) {
					this.cusId = this.sbmidarr[0];
				}
				if (!this.cusId) {
					this.$message.error("请选择要操作的数据！");
					return;
				}
				this.EidtTitle = "查看";
				this.dialogVisibles = true;
				this.inventoryClassList();
				this.getHelperVBP();
				this.getProvinceCityTree();
				this.customerInfo();
			},
			//添加
			adduser() {
				this.cusId = '';
				this.dialogVisibles = true;
				this.EidtTitle = "新增";
				this.inventoryClassList();
				this.getHelperVBP();
				this.getProvinceCityTree();
				this.$nextTick(() => {
					this.$refs.comtable.$refs.multipleTable.setCurrentRow('');
				})
			},
			// 修改
			update() {
				if (this.sbmidarr.length === 1) {
					this.cusId = this.sbmidarr[0];
				}
				if (!this.cusId) {
					this.$message.error("请选择要操作的数据！");
					return;
				}
				this.dialogVisibles = true;
				this.EidtTitle = "编辑";
				this.inventoryClassList();
				this.getHelperVBP();
				this.getProvinceCityTree();
				this.customerInfo();
			},
			// 复制
			copy() {
				if (this.sbmidarr.length === 1) {
					this.cusId = this.sbmidarr[0];
				}
				if (!this.cusId) {
					this.$message.error("请选择要操作的数据！");
					return;
				}
				this.dialogVisibles = true;
				this.EidtTitle = "复制";
				this.inventoryClassList();
				this.getHelperVBP();
				this.getProvinceCityTree();
				this.customerInfo();
			},
			del() {
				if (!this.sbmidarr.length) {
					this.$message.error("请选择要删除的数据！");
					return;
				}
				this.dialogVisibledel = true;
			},
			async dialogOKdel() {
				let {
					code,
					message
				} = await DeleteIMSNTSData({
					INMIDs: this.sbmidarr,
				});
				if (code == 0) {
					this.$message({
						type: "success",
						message: "删除成功",
					});
					this.sbmidarr = [];
					this.canceldel();
					this.$parent.customerList();
				} else {
					this.$message({
						type: "error",
						message: message,
					});
				}
			},
			canceldel() {
				this.dialogVisibledel = false;
			},
			// 详情
			async customerInfo() {
				let {
					code,
					data
				} = await InfoIMSNTSData({
					INMID: this.cusId,
				});
				if (code == 0) {
					this.$refs.addjxa[0].modelvalue = data.InvClass;
					this.$refs.addjxa[1].modelvalue = data.INType;
					this.$refs.addjxa[2].modelvalue = data.INName;
					this.$refs.addjxa[3].modelvalue = data.ExecuteDate;
					this.$refs.addjxa[4].modelvalue = data.ProvinceCityDetails;
					this.$refs.addjxa[5].modelvalue = data.LEVEL3Details;
					this.$refs.addjxa[6].modelvalue = data.InvNameDetails;
					this.$refs.addjxa[7].modelvalue = data.InvAddCodes;
					this.$refs.addjxa[8].modelvalue = data.LowNTSPrice;
					this.$refs.addjxa[9].modelvalue = data.HighNTSPrice;
					this.$refs.addjxa[10].modelvalue = data.HighIMSPrice;
					this.$refs.addjxa[11].modelvalue = data.CustomerDetails;
					this.$refs.addjxa[12].modelvalue = data.HospitalDetails || [];

					if (data.CustomerDetails && data.CustomerDetails.length) {
						this.fromdataadd[11].options = [];
						data.CustomerDetails.forEach((it, ix) => {
							this.fromdataadd[11].options.push({
								key: it,
								value: data.CustomerDetailNames[ix],
							})
						})
					}

					if (data.HospitalDetails && data.HospitalDetails.length) {
						this.fromdataadd[12].options = [];
						data.HospitalDetails.forEach((it, ix) => {
							this.fromdataadd[12].options.push({
								key: it,
								value: data.HospitalDetailNames[ix],
							})
						})
					}
					this.$forceUpdate();
					this.handInvClass();
				}
			},
			//弹窗提交
			async dialogOK() {
				if (this.EidtTitle == "查看") {
					this.dialogVisibles = false;
				} else if (this.EidtTitle == "新增" || this.EidtTitle == "复制") {
					let {
						code,
						message
					} = await AddIMSNTSData({
						InvClass: this.$refs.addjxa[0].modelvalue,
						INType: this.$refs.addjxa[1].modelvalue,
						INName: this.$refs.addjxa[2].modelvalue,
						ExecuteDate: this.$refs.addjxa[3].modelvalue,
						ProvinceCityDetails: this.$refs.addjxa[4].modelvalue,
						LEVEL3Details: this.$refs.addjxa[5].modelvalue,
						InvNameDetails: this.$refs.addjxa[6].modelvalue,
						InvAddCodes: this.$refs.addjxa[7].modelvalue,
						LowNTSPrice: this.$refs.addjxa[8].modelvalue,
						HighNTSPrice: this.$refs.addjxa[9].modelvalue,
						HighIMSPrice: this.$refs.addjxa[10].modelvalue,
						CustomerDetails: this.$refs.addjxa[11].modelvalue,
						HospitalDetails: this.$refs.addjxa[12].modelvalue,
					});
					if (code == 0) {
						this.$message({
							type: "success",
							message: "新增成功",
						});
						this.$parent.customerList();
						this.$refs.addjxa.map((item, index) => {
							item.modelvalue = "";
						});
						this.dialogVisibles = false;
					} else {
						this.$message({
							type: "error",
							message: message,
						});
					}
				} else {
					let {
						code,
						message
					} = await EditIMSNTSData({
						INMID: this.cusId,
						InvClass: this.$refs.addjxa[0].modelvalue,
						INType: this.$refs.addjxa[1].modelvalue,
						INName: this.$refs.addjxa[2].modelvalue,
						ExecuteDate: this.$refs.addjxa[3].modelvalue,
						ProvinceCityDetails: this.$refs.addjxa[4].modelvalue,
						LEVEL3Details: this.$refs.addjxa[5].modelvalue,
						InvNameDetails: this.$refs.addjxa[6].modelvalue,
						InvAddCodes: this.$refs.addjxa[7].modelvalue,
						LowNTSPrice: this.$refs.addjxa[8].modelvalue,
						HighNTSPrice: this.$refs.addjxa[9].modelvalue,
						HighIMSPrice: this.$refs.addjxa[10].modelvalue,
						CustomerDetails: this.$refs.addjxa[11].modelvalue,
						HospitalDetails: this.$refs.addjxa[12].modelvalue,
					});
					if (code == 0) {
						this.$message({
							type: "success",
							message: "修改成功",
						});
						this.$refs.addjxa.map((item, index) => {
							item.modelvalue = "";
						});
						this.cusId = '';
						this.$parent.customerList();
						this.dialogVisibles = false;
					} else {
						this.$message({
							type: "error",
							message: message,
						});
					}
				}
			},
			handleCurrentChange(pageindex) {
				this.$emit("handleCurrentChange", pageindex);
			},
			handleSizeChange(paegSzie) {
				this.$emit("handleSizeChange", paegSzie);
			},
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"));
				data.Menus[4].Nodes.map((item, index) => {
					if (item.NodeID == 1068) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 1069) {
								this.qus = items.Nodes;
							}
						});
					}
				});
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == "add") {
							this.qx.add = true;
						} else if (item.NodeName == "edit") {
							this.qx.update = true;
						} else if (item.NodeName == "delete") {
							this.qx.del = true;
						} else if (item.NodeName == "browse") {
							this.qx.browse = true;
						}
					});
				}
			},
		},
		watch: {
			dialogVisibles: {
				handler(val) {
					if (!val) {
						this.$refs.addjxa.map((item, index) => {
							item.modelvalue = "";
						});
					}
				},
				deep: true,
			},
			EidtTitle: {
				handler(newVal, oldVal) {
					if (newVal == "查看") {
						this.fromdataadd.forEach((item, index) => {
							item.disabled = true;
						});
					} else {
						this.fromdataadd.forEach((item, index) => {
							item.disabled = false;
						});
					}
				},
			},
		},
	};
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.line {
			width: 100%;
			height: 1px;
			background: #eaecef;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
			margin-top: 30px;
		}

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.Code {
		width: 100%;
	}

	.type {
		width: 98.6%;
		border: 1px solid #e6e6e6;
		font-size: 17px;
		color: #333333;
		font-weight: 500;
		padding: 10px 10px 10px 0;
		margin: 0 auto;

		.type-top {
			width: 100%;
			border-bottom: 1px solid #e6e6e6;
			font-weight: bold;
			color: #333333;
			font-size: 14px;
			text-indent: 16px;
			line-height: 16px;
			padding-bottom: 10px;

			.type-top-left {
				width: 3px;
				height: 16px;
				display: inline-block;
				background-color: #e71d43;
				float: left;
			}
		}

		.type-text {
			margin-top: 12px;
		}

		.CodeText {
			display: inline-block;
			width: 430px;
			margin-left: 30px;
			font-size: 14px;
			font-weight: 500;
			// border: 1px solid red;
			color: #999999;
			margin-top: 12px;
			position: relative;

			.imgBox {
				display: inline-block;
				width: 96px;
				height: 96px;
				border: 1px solid #e6e6e6;

				img {
					width: 96px;
					height: 96px;
					vertical-align: top;
				}
			}

			span {
				display: inline-block;
				color: #333333;
				font-weight: 500;

				img {
					width: 96px;
					height: 96px;
					vertical-align: top;
				}
			}
		}
	}

	.LicenseRfrom {
		width: 100%;
		height: 500px;
		overflow: scroll;
	}

	.detailedCss {
		min-width: 100px;
		max-width: 200px;
		height: 32px;
		background-color: #fce8ec;
		border: 1px solid #e71d43;
		color: #e71d43;
		font-size: 14px;
		text-align: center;
		line-height: 32px;
		margin: 10px 10px 10px 0;
	}

	.imgTop {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 75px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop2 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 145px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop3 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 175px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}

	.imgTop4 {
		width: 96px;
		height: 96px;
		background-color: #000;
		opacity: 0.3;
		position: absolute;
		top: 0;
		left: 130px;

		.imgPhoto {
			width: 17.21px;
			height: 17.21px;
			position: relative;
			top: 40px;
			left: 40px;
			cursor: pointer;
		}
	}
</style>